(function () {
    'use strict';

    var gettext = angular.identity;

    angular
        .module('app.courseHandicap')
        .enumeration('courseContactType', {
            Architect: [, gettext('Architect')],
            Manager: [, gettext('Manager')],
            Professional: [, gettext('Professional')],
            Superintendent: [, gettext('Superintendent')],
            HeadProfessional: [, gettext('Head Professional')],
            RetiredProfessional: [, gettext('Retired Professional')],
            LifeProfessional: [, gettext('Life Professional')],
            MasterProfessional: [, gettext('Master Professional')],
            CandidateForMembership: [, gettext('Candidate for Membership')],
            HeadTeachingProfessional: [, gettext('Head Teaching Professional')],
            TeachingProfessional: [, gettext('Teaching Professional')],
            ExecutiveProfessional: [, gettext('Executive Professional')]
        })
        .constant('courseHandicap_resources', {
            courseHandicapRequestFailed: gettext('Failed to retrieve course handicap data.')
        });
})();